import { render } from "./SettingTabItem.vue?vue&type=template&id=3df3582f&ts=true"
import script from "./SettingTabItem.vue?vue&type=script&lang=ts"
export * from "./SettingTabItem.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__